import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/constants';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 max-w-3xl mx-auto" data-id="element-53">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 flex items-center justify-center gap-2" data-id="element-54">
        <span data-id="element-55">❓</span> LO QUE MÁS NOS PREGUNTAN
      </h2>

      <div className="space-y-4" data-id="element-56">
        {faqs.map((faq, i) => <div key={i} className="bg-surface border border-zinc-800 rounded-xl overflow-hidden" data-id="element-57">
            <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-58">
              <span className="font-bold pr-4" data-id="element-59">{faq.q}</span>
              <ChevronDown className={`w-5 h-5 text-zinc-500 shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-60" />
            </button>

            <AnimatePresence data-id="element-61">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-62">
                  <div className="px-6 pb-5 text-zinc-400 text-sm leading-relaxed border-t border-zinc-800/50 pt-4" data-id="element-63">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}